import React, { FC } from 'react';
import { Institution } from 'types/Institution';
import instIcon from 'assets/images/partneringInstitutions.svg';
import { capitalizeEveryWord } from 'helpers/capitalizeEveryWord';
import ShelterCard from './ShelterCard';


interface IInstitutionCardProps {
    institution: Institution;
}


const InstitutionCard: FC<IInstitutionCardProps> = ({ institution }) => {

    return (
        <div className='card mb-4 shadow inst-card px-3'>
            <div className='row g-0'>
                <div className='col-lg-3 p-3 d-flex flex-column align-items-center justify-content-center text-center'>
                    <img src={instIcon} alt='' />
                    <h5>{capitalizeEveryWord(institution.name)}</h5>
                    <h6 className="mb-2">{capitalizeEveryWord(institution.addressOne, 'PO')}</h6>
                    {institution.addressTwo && institution.addressTwo !== '' &&
                        <h6>{institution.addressTwo}</h6>
                    }
                    <h6 className="mb-2">{institution.cityStateZip}</h6>
                </div>
                <div className='col-lg-9'>
                    <div className='card-body'>
                        <div className='row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4  g-4'>
                            {institution.shelters.map((shelter, i) => <ShelterCard shelter={shelter} key={'shelter-' + i} />)}
                        </div>

                    </div>
                </div>
            </div>

        </div>


    )
}

export default InstitutionCard;




















